<template>
    <div class="voucher-box" @click="onClose">
        <div class="base-yx-voucher" :class="{'yxvoucher-sp': $store.state.screen == 1}" @click.stop>
            <div class="header">
                <div class="back-img" @click="onBack">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">选择代金券</div>
                <div class="service-img" @click="$router.push('/base-service')">
                    <img class="ser" src="~images/user_service.png" />
                </div>
            </div>
            <div class="content">
                <div class="transient" @click="onSel">
                    <div>暂不使用代金券</div>
                    <div class="sel" :class="{isbor: issel}">
                        <img src="~images/sel.png" v-show="issel" />
                    </div>
                </div>
                <div>
                    <div class="list" :style="{background: 'url(' + bgImgy + ') no-repeat'}" v-for="(item, index) in list" :key="index">
                        <div class="money">
                            <div>￥<span>{{item.money}}</span></div>
                            <div class="full">满{{item.limit_use_money}}元可用</div>
                        </div>
                        <div class="center">
                            <div class="mark">
                                <span v-if="item.type == 1">通用券</span>
                                <span v-if="item.type == 2">专用券</span>
                            </div>
                            <div class="name">{{item.name}}</div>
                            <div class="tips">{{item.start_time | dasTime}}至{{item.end_time | dasTime}}</div>
                        </div>
                        <div class="receive" @click="onDjq(item)">立即使用</div>
                    </div>
                </div>
                <transition name="component-fade" mode="out-in">
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import moment  from 'moment'
    import TheTips from '@/components/TheTips'

    export default {
        name: 'BaseYxVoucher',
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                bgImgy: require('images/voucher.png'),
                list: [],
                issel: false,
                appid: null,
                channel: null,
                uid: null,
                appkey: null
            }
        },
        filters: {
            dasTime (time) {
                return moment.unix(time).format('YYYY-MM-DD')
            }
        },
        methods: {
            onBack () {
                if (this.issel == true) {
                    sessionStorage.removeItem('voucher')
                }
                this.$router.back()
            },
            onSel () {
                this.issel = !this.issel
            },
            // 关闭支付页面
            onClose () {
                let that = this
                sessionStorage.clear()
                if (that.config.system == 1) {
                    window.Android.closePay(false, '')
                } else if (that.config.system == 2) {
                    window.webkit.messageHandlers.wz_callOC.postMessage({
                        method: 'closePay',
                        param: {
                            payState: false,
                            payId: ''
                        }
                    })
                }
            },
            onDjq (item) {
                if (this.$route.query.paymoney >= item.limit_use_money) {
                    sessionStorage.setItem('voucher', JSON.stringify({
                        id: item.id,
                        money: item.money
                    }))
                    this.$router.back()
                } else {
                    this.msg = '不符合使用条件'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            },
            // 获取代金券列表
            getVoucher () {
                let options = {
                    appid: this.appid,
                    channel: this.channel,
                    uid: this.uid,
                    system: this.config.system,
                    // page: 1
                };
                options.sign = this.util.getSign(options, this.appkey)
                this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=voucher&a=voucherGetList', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data
                        sessionStorage.setItem('setYxVoucher', JSON.stringify(this.list))
                    }
                })
            }
        },
        created () {
            this.appid = this.$route.query.appid
            this.channel = this.$route.query.channel
            this.uid = this.$route.query.uid
            this.appkey = this.$route.query.appkey
            if (sessionStorage.getItem('setYxVoucher')) {
                this.list = JSON.parse(sessionStorage.getItem('setYxVoucher'))
            } else {
                this.getVoucher()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    .voucher-box {
        width: 100%;
        height: 100%;
    }
    // 横屏css
    .base-yx-voucher {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .back {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 60px 60px 0;
        }
        .transient {
            height: 120px;
            font-size: 42px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.2);
            padding: 0 45px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .sel {
                width: 60px;
                height: 60px;
                border: 3px solid #fff;
                border-radius: 50%;
                position: relative;
                img {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: -3px;
                    left: -3px;
                }
            }
            .isbor {
                border: 0;
            }
        }
        .list {
            height: 270px;
            background-size: 100% 270px!important;
            margin-top: 30px;
            display: flex;
            .money {
                width: 270px;
                font-size: 33px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                span {
                    font-size: 60px;
                }
                .full {
                    margin-top: 30px;
                }
            }
            .center {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-left: 45px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                .mark {
                    width: 138px;
                    height: 48px;
                    font-size: 33px;
                    border-radius: 3px;
                    background: $color;
                    margin-bottom: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .name {
                    font-size: 45px;
                    margin-bottom: 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .tips {
                    font-size: 33px;
                    color: rgba(255, 255, 255, 0.5);
                }
            }
            .receive {
                width: 138px;
                font-size: 39px;
                writing-mode: tb-rl;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .list:first-child {
            margin-top: 40px;
        }
        .list:last-child {
            margin-bottom: 60px;
        }
    }
    // 竖屏css
    .yxvoucher-sp {
        width: 82%;
        height: 80%;
        border-radius: 60px 0 0 0;
        overflow: hidden;
        position: absolute;
        right: 0;
        bottom: 0;
        .header {
            height: 240px;
            .back-img {
                width: 290px;
                height: 240px;
                .back {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .content {
            padding: 90px 90px 0;
        }
        .transient {
            height: 200px;
            font-size: 76px;
            border-radius: 32px;
            padding: 0 81px;
            .sel {
                width: 90px;
                height: 90px;
                border: 5px solid #fff;
                img {
                    width: 90px;
                    height: 90px;
                    top: -5px;
                    left: -5px;
                }
            }
            .isbor {
                border: 0;
            }
        }
        .list {
            height: 400px;
            background-size: 100% 400px!important;
            margin-top: 54px;
            .money {
                width: 400px;
                font-size: 50px;
                span {
                    font-size: 80px;
                }
                .full {
                    margin-top: 54px;
                }
            }
            .center {
                padding-left: 35px;
                .mark {
                    width: 250px;
                    height: 87px;
                    font-size: 55px;
                    border-radius: 5px;
                    margin-bottom: 27px;
                }
                .name {
                    font-size: 70px;
                    margin-bottom: 18px;
                }
                .tips {
                    font-size: 60px;
                }
            }
            .receive {
                width: 204px;
                font-size: 70px;
            }
        }
        .list:first-child {
            margin-top: 72px;
        }
        .list:last-child {
            margin-bottom: 90px;
        }
    }
</style>